import { Apollo, APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApplicationConfig, inject } from '@angular/core';
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';
import extractFiles from 'extract-files/extractFiles.mjs';
import isExtractableFile from 'extract-files/isExtractableFile.mjs';
import { environment } from '../../../environments/environment';

const uri = `${environment.scattre.threed}/graphql/`;

export function apolloOptionsFactory(): ApolloClientOptions<any> {
  const httpLink = inject(HttpLink);
  return {
    link: httpLink.create({
      uri,
      extractFiles: (body: any) => extractFiles(body, isExtractableFile) as any,
    }),
    cache: new InMemoryCache(),
  };
}

export const graphqlProvider: ApplicationConfig['providers'] = [
  Apollo,
  {
    provide: APOLLO_NAMED_OPTIONS,
    useFactory(httpLink: HttpLink): NamedOptions {
      return {
        threed: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: `${environment.scattre.threed}/graphql/`,
            extractFiles: (body: any) => extractFiles(body, isExtractableFile) as any,
          }),
        },
        account: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: `${environment.scattre.account}/graphql/`,
            extractFiles: (body: any) => extractFiles(body, isExtractableFile) as any,
          }),
        },
        ai: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: `${environment.scattre.ai}/graphql/`,
            extractFiles: (body: any) => extractFiles(body, isExtractableFile) as any,
          }),
        },
        saleor: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: `${environment.saleor.server}/graphql/`,
            extractFiles: (body: any) => extractFiles(body, isExtractableFile) as any,
          }),
        },
      };
    },
    deps: [HttpLink],
  },
];
